import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-months-selector',
  standalone: true,
  imports: [CommonModule, MatFormField, FormsModule, MatLabel, MatSelect, MatOption],
  templateUrl: './months-selector.component.html',
  styleUrl: './months-selector.component.scss',
})
export class MonthsSelectorComponent implements OnInit, OnDestroy {
  private readonly _destroying$: Subject<void> = new Subject<void>();
  private readonly _updateMonth$: EventEmitter<void> = new EventEmitter(true);

  private _months: string[] = [];
  private _selectedMonths: string[] = [this.getLabelForMonth(new Date().getMonth() - 1)];
  private _availableMonths: string[] | undefined = undefined;
  private _scssClassToApply: string | undefined = undefined;

  get selectedMonths(): string[] {
    return this._selectedMonths;
  }

  // Fonction Input appelée quand on change un mois
  @Input()
  set selectedMonthsInput(value: string[] | []) {
    if (value && value !== this._selectedMonths) {
      this._selectedMonths = [...value];
    }
  }

  // Fonction appelé a la selection du mois interne
  set selectedMonths(value: string[] | []) {
    if (value && value !== this._selectedMonths) {
      this._selectedMonths = [...value];
      this.onSelectionChange(this._selectedMonths);
    }
  }

  get months(): string[] {
    return this._months;
  }

  set months(value: string[]) {
    if (this._months !== value) {
      this._months = value;
      this._updateMonth$.emit();
    }
  }

  @Input()
  set availableMonths(value: string[] | undefined) {
    this._availableMonths = value;
    if (value && Array.isArray(value)) {
      this.months = [...value];
    }
  }

  get scssClassToApply(): string | undefined {
    return this._scssClassToApply;
  }

  @Input()
  set scssClassToApply(value: string) {
    if (this._scssClassToApply !== value) {
      this._scssClassToApply = value;
    }
  }

  get availableMonths(): string[] | undefined {
    return this._availableMonths;
  }

  @Output() onMonthsSelectionChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor() {
    this._updateMonth$.subscribe(() => {
      this._onMonthsUpdate();
    });
  }

  ngOnInit(): void {
    if (this.availableMonths && Array.isArray(this.availableMonths)) {
      this.months = [...this.availableMonths];
    } else {
      this.initializeMonths();
    }

    if (!this._selectedMonths || this._selectedMonths.length === 0) {
      this.setDefaultMonth();
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  onSelectionChange(value: any): void {
    if (value !== undefined) {
      this._selectedMonths = value;
    }
    this.onMonthsSelectionChange.emit(this.selectedMonths);
  }

  private initializeMonths(): void {
    const currentMonth = new Date().getMonth();
    for (let i = currentMonth; i >= 2010; i--) {
      this.months.push(this.getLabelForMonth(i));
    }
  }

  private setDefaultMonth(): void {
    const currentMonth = this.getLabelForMonth(new Date().getMonth());
    if (this.months.includes(currentMonth)) {
      this.selectedMonths = [currentMonth];
    } else {
      this.selectedMonths = [this.getLabelForMonth(this.months.length - 1)];
    }
  }

private _onMonthsUpdate(): void {
  if (!this._selectedMonths || this._selectedMonths.length === 0) {
    return;
  }

  // garder seulement les mois encore valides
  this._selectedMonths = this._selectedMonths.filter(m => this.months.includes(m));
}

  private getLabelForMonth(month: number): string {
    return (
      month.toString() + ' - ' + new Date(0, month - 1).toLocaleString('fr', { month: 'long' })
    );
  }
}
